/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Faq_A3Inputs */

const en_fw_faq_a3 = /** @type {(inputs: Fw_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Oreco Tachibana’s manga ran on Shogakukan’s Ura Sunday and MangaONE from January 2023 to February 2026 and has over four million copies in print. VIZ Media and Comikey publish it in English.`)
};

const zh_fw_faq_a3 = /** @type {(inputs: Fw_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有。原作为橘オレコ的同名漫画，2023 年 1 月至 2026 年 2 月在小学馆「裏サンデー」与「マンガワン」连载，累计发行超过 400 万部；英文版由 VIZ Media 与 Comikey 发行。`)
};

/**
* | output |
* | --- |
* | "Yes. Oreco Tachibana’s manga ran on Shogakukan’s Ura Sunday and MangaONE from January 2023 to February 2026 and has over four million copies in print. VIZ Me..." |
*
* @param {Fw_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_faq_a3 = /** @type {((inputs?: Fw_Faq_A3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Faq_A3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_faq_a3(inputs)
	return zh_fw_faq_a3(inputs)
});
export { fw_faq_a3 as "fw.faq.a3" }